import React from "react";
import { Radio } from "flowbite-react";
import CheckboxLabel from "../labels/CheckboxLabel";
import tenkenTheme from "../../../configs/themes/tenkenTheme";

const RadioInput = ({
  id,
  name,
  value,
  checked,
  label,
  className,
  onChange,
  classLabel,
  isDisabled = false,
  isSmall = false
}) => {
  const theme = isSmall ? tenkenTheme.small_radio : tenkenTheme.radio
  return (
    <div className={`flex items-center ${className}`}>
      <Radio
        theme={theme}
        root="base"
        id={id}
        name={name}
        value={value}
        checked={checked?? false}
        onChange={onChange}
        className="cursor-pointer"
        disabled={isDisabled}
      />
      {label && <CheckboxLabel text={label} className={classLabel} htmlFor={id} checked={checked}/>}
    </div>
  );
};

export default RadioInput;
